import React, { ReactNode } from 'react'
import Icon from '../icon'

type ModalProps = {
  open: boolean
  setOpen: (open: boolean) => void
  children: React.ReactNode
  onCloseCallback?: () => void
  title?: ReactNode
  childrenClassName?: string
  position?: 'right' | 'center'
  fullScreen?: boolean
  showHeader?: boolean
}

const ModalComponent: React.FC<ModalProps> = ({
  open,
  setOpen,
  children,
  onCloseCallback,
  title = '',
  childrenClassName = '',
  position = 'center',
  fullScreen = false,
  showHeader = true,
}) => {
  const closeModal = () => {
    setOpen(false)
    onCloseCallback && onCloseCallback()
  }

  return (
    open && (
      <div
        className={`
        fixed z-[999] h-screen max-h-[100dvh] w-screen 
        inset-0 flex items-end md:items-center
        ${position === 'center' && 'md:p-4 justify-center'}
        ${position === 'right' && 'md:p-4 justify-end'}
        ${fullScreen && '!p-0'}
        `}
      >
        <div
          className="fixed inset-0 z-10 bg-black/60 h-screen w-screen"
          onClick={closeModal}
        />
        <div
          className={`
          bg-white z-30 w-full md:max-w-128 h-fit p-4 md:p-6
          flex flex-col gap-6
          ${position === 'center' && 'max-h-[90%] rounded-t-lg md:rounded-lg'}
          ${position === 'right' && '!h-[100%] rounded-xl'}
          ${fullScreen && '!h-full max-h-full !w-full !rounded-none'}
          ${childrenClassName}
          `}
        >
          {showHeader && (
            <div className="flex flex-col gap-6">
              <button type="button" className="w-fit" onClick={closeModal}>
                <Icon
                  id="close-circle-filled"
                  width={24}
                  height={24}
                  className=""
                />
              </button>

              {title && (
                <div className="text-xl md:text-2xl font-recoleta font-semibold tracking-[-0.001em]">
                  {title}
                </div>
              )}
            </div>
          )}

          <div className={`overflow-y-scroll h-full hide-scroll-bar`}>
            {children}
          </div>
        </div>
      </div>
    )
  )
}

export default ModalComponent
